import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function RecommendedSection() {
  const recommendedComics = comics.filter((c) => c.isRecommended).slice(0, 8);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-6 md:mb-8">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-1">
            <i className="ri-thumb-up-line text-accent-500 mr-2"></i>
            编辑推荐
          </h2>
          <p className="text-sm text-foreground-500">编辑部精选的高品质韩漫，每一部都值得一读</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {recommendedComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.slug}`}
              className="group flex gap-3 md:gap-4 p-3 md:p-4 bg-background-50 rounded-lg hover:bg-background-50/80 transition-colors duration-200"
            >
              <div className="w-[80px] md:w-[100px] shrink-0 overflow-hidden rounded-md">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  className="w-full aspect-[2/3] object-cover object-top group-hover:scale-105 transition-transform duration-400"
                />
              </div>
              <div className="flex flex-col justify-between min-w-0 flex-1">
                <div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                    {comic.description.slice(0, 60)}...
                  </p>
                </div>
                <div className="flex items-center gap-2 flex-wrap mt-1">
                  {comic.tags.slice(0, 2).map((tag) => (
                    <span
                      key={tag}
                      className="inline-block px-2 py-0.5 rounded text-[10px] md:text-xs bg-secondary-100 text-secondary-700"
                    >
                      {tag}
                    </span>
                  ))}
                  <span className="text-xs text-foreground-400 flex items-center gap-0.5">
                    <i className="ri-star-fill text-accent-500 text-[10px]"></i>
                    {comic.rating}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}